import { ValueOf } from '@/shared/lib/interfaces/utils';

export const USER_DOMAIN = {
	YACHTING: 'yachting',
	INDUSTRIAL: 'industrial',
	RESIDENTIAL: 'residential',
} as const;

export type USER_DOMAIN = ValueOf<typeof USER_DOMAIN>;
